import { useNavigate, useParams } from "react-router-dom";

export default function Meditation() {
  const navigate = useNavigate();
  const { id, moduleId } = useParams();

  const handleGoInside = () => {
    navigate(`/${id}/${moduleId}/meditation`);
  };

  return (
    <div className="min-h-screen bg-white px-6 py-8">

      {/* Bilgilendirme Kartı */}
      <div className="bg-gradient-to-br from-blue-50 to-indigo-50 border border-blue-200 rounded-xl p-6 mb-8">
        <div className="flex items-start gap-4">
          <div className="flex-1">
            <h3 className="text-blue-800 text-sm font-semibold mb-2">Birlikte Meditasyon</h3>
            <p className="text-blue-700 text-sm leading-relaxed">
              Meditasyonu başlattığınız anda sizinle birlikte şu anda meditasyon yapan 
              Jodiac kullanıcılarını görebilirsiniz.
            </p>
          </div>
        </div>
      </div>

      {/* Meditasyonu Başlat Butonu - Modern Tasarım */}
      <button
        onClick={handleGoInside}
        className="w-full group relative overflow-hidden bg-gradient-to-r from-[#3DA7B5] to-[#5ABCC8] hover:from-[#2F8894] hover:to-[#4A9BA6] text-white rounded-2xl mb-8 p-6 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98]"
      >
        <div className="relative z-10 flex items-center justify-center gap-3">
          <div className="text-center">
            <p className="text-white text-lg font-bold mb-1">
              Meditasyonu Başlat
            </p>
            <p className="text-white/80 text-sm">
              Huzurlu bir yolculuğa çıkın
            </p>
          </div>
          <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
            <span className="text-lg">→</span>
          </div>
        </div>
        <div className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/10 to-white/0 transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
      </button>

      {/* Alt boşluk */}
      <div className="h-20"></div>
    </div>
  );
}

